// @flow

import React from 'react';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import ImagesDropzone from '../ImagesDropzone/ImagesDropzone';
import _ from 'lodash/fp';

export type Props = {
  activeRoomType: ?any,
  roomTypes: any[],
  images: any[],
  uploads: Object,
  onRoomTypeSelect: Function,
  onUpload: Function,
  onUploadAbort: Function,
  onRemove: Function,
};

const RoomTypeImages = ({
  activeRoomType,
  roomTypes,
  images,
  uploads,
  onRoomTypeSelect,
  onUpload,
  onUploadAbort,
  onRemove,
}: Props) => (
  <div className="RoomTypeImages">
    <label>
      Inspirationsbilder
    </label>
    <SelectFormInput
      input={{
        value: activeRoomType,
        onBlur: _.noop,
        onChange: roomType => onRoomTypeSelect(roomType),
      }}
      placeholder={'Rumstyp'}
      meta={{}}
      valueKey="id"
      labelKey="name"
      options={roomTypes} />
    <div className="list">
      {activeRoomType &&
        <ImagesDropzone
          images={_.filter({roomTypeId: activeRoomType.id}, images)}
          uploads={uploads[activeRoomType.id] || []}
          onUpload={onUpload}
          onRemove={onRemove}
          onUploadAbort={onUploadAbort} />
      }
    </div>
  </div>
);

export default RoomTypeImages;



// WEBPACK FOOTER //
// ./src/components/RoomTypeImages/RoomTypeImages.js